import React from 'react'
import PropTypes from 'prop-types'

class Tab extends React.Component {
  static propTypes = {
    /* Tab title */
    title: PropTypes.string.isRequired,
    /* Custom classnames */
    className: PropTypes.string,
    /* Check if table is visible (controlled by NavTab) */
    visible: PropTypes.bool,
    /* Tab content */
    children: PropTypes.node,
  }

  render() {
    const { className, visible } = this.props

    return (
      <div className={`tab ${visible ? 'show' : ''} ${className || ''}`}>
        {this.props.children}
      </div>
    )
  }
}

export default Tab
export { Tab }
